import { render, staticRenderFns } from "./create-orders.vue?vue&type=template&id=564e7a01&scoped=true"
import script from "./create-orders.vue?vue&type=script&lang=js"
export * from "./create-orders.vue?vue&type=script&lang=js"
import style0 from "./create-orders.vue?vue&type=style&index=0&id=564e7a01&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "564e7a01",
  null
  
)

export default component.exports